import React from 'react';
import { inject, observer } from 'mobx-react';
import styles from './index.module.scss';
import { BASE_IMG_URL } from '@images/imageUrls';
import classNames from 'classnames';
import CommonAlert from '@components/commonAlert';
import type { ThreadAction } from '@stores/thread/action';
import type { UserAction } from '@stores/user/action';
import { DatePicker } from 'antd';
import Toast from '@components/Toast';
import { getManageOperationSuccessMessage } from '../operationMessage';
import ThreadConversion, { type ThreadConversionPayload } from '@components/threadConversion';
import { getThreadConversionBlockedReason, shouldHideThreadConversion } from '@utils/threadConversion';

// import dayjs from 'dayjs';
// import duration from 'dayjs/plugin/duration';
// // 启用 duration 插件
// dayjs.extend(duration);
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
dayjs.locale('zh-cn');

// 检查定时是否过期
const isScheduleExpired = (fixedAt: any): boolean => {
    if (!fixedAt) return true;
    return dayjs(fixedAt).isBefore(dayjs());
};

// 简化接口定义
interface PCManagePermissionsProps {
    thread?: ThreadAction;
    // 基础属性
    id: any
    threadData: any
    topicList?: any[]
    className?: string;
    type?: number;    // 帖子类型，1为帖子
    
    // 状态属性
    isSelf?: boolean;
    isApproved?: boolean;
    isEssence?: boolean;  // 是否加精
    isSticky?: boolean | number;   // 是否置顶
    isSink?: boolean; // 是否沉帖
    isHidden?: boolean;   // 是否隐藏
    isDisplay?: boolean;  // 是否屏蔽
    //   isHot?: boolean;  // 是否热门
    isRecommend?: boolean; // 是否推荐
//   isProhibited?: boolean;   // 禁止评论
    stickyType?: any // 置顶类型
    stickyAt?: any  // 话题置顶时间
    showIndexAt?: any  // 首页置顶时间
    showIndex?: boolean;
    
    // deletePopupStatus?: boolean  // 删除弹框是否显示
    
  
    // 权限控制
    canEdit?: boolean;
    canDelete?: boolean;
    canEssence?: boolean;
    canStick?: boolean;
    //   canSolve?: boolean;
    canSink?: boolean;
    canHidden?: boolean;
    canDisplay?: boolean;
    //   canHot?: boolean;
    canRecommend?: boolean;
    canConvert?: boolean;
    //   canProhibitedComment?: boolean;
  
    // 操作函数
    handleSetState?: any
    handleEdit?: Function;  // 编辑
    handleDelete?: Function;  // 确认删除
    handleEssence?: Function; // 精华
    handleStick?: Function; // 确认置顶
    //   handleSolve?: Function;  // 帮他处理
    handleSink?: Function;  // 沉帖
    handleHidden?: Function;  // 隐藏本帖
    handleDisplay?: Function; // 屏蔽
    //   handleHot?: Function;  // 热门
    handleSite?: Function;  // 推荐
    //   handleProhibited?: Function; // 禁止评论
    handleReport?: Function;  // 确认举报
    getThreadDetail?: Function  // 获取详情接口数据，用于更新状态
    goBack?: any    // 返回上一页事件
    handleConvert?: (payload: ThreadConversionPayload) => Promise<void>;
    
    // MobX stores (可选)
    app?: any;
    site?: any;
    user?: UserAction;
}
interface PCManagePermissionsState {
    isEssenceStatus: any
    isStickStatus: boolean | number;
    isSinkStatus: boolean;
    isHiddenStatus: boolean;
    isDisplayStatus: boolean;
    // isHotStatus: boolean;
    isRecommendStatus: boolean;
    // isProhibitedStatus: boolean;
    stickyPopupStatus: any
    stickyTypeValue: any
    stickyTopicIdValue: any
    stickyAtValue: any
    showIndexAtValue: any
    deletePopupStatus: any
    conversionVisible: boolean;
}

@inject('app', 'site', 'user', 'thread')
@observer
class PCManagePermissions extends React.Component<PCManagePermissionsProps, PCManagePermissionsState> {
    static defaultProps = {
        isApproved: true,
        className: '',
    };
    constructor(props: PCManagePermissionsProps) {
        super(props);
        // console.log('PCManagePermissions props:', props);
        // console.log('isSticky:', props.isSticky, 'type:', typeof props.isSticky);
        // console.log('stickyAt:', props.stickyAt, 'type:', typeof props.stickyAt);
        // console.log('stickyType:', props.stickyType, 'type:', typeof props.stickyType);
        
        // 从 props 中获取初始值设置到 state
        // isSticky 应该是 boolean，表示是否置顶
        // stickyType 应该是数字，表示置顶类型（0=不置顶，1=话题，2=首页）
        const stickyTypeValue = this.getStickyTypeValueFromProps(props);
        const isStickyBoolean = stickyTypeValue > 0;
        
        // console.log('Calculated isStickyBoolean:', isStickyBoolean, 'stickyTypeValue:', stickyTypeValue);
        
        this.state = {
            isEssenceStatus: props.isEssence || false,
            isStickStatus: isStickyBoolean,
            isSinkStatus: props.isSink || false,
            isHiddenStatus: props.isHidden || false,
            isDisplayStatus: props.isDisplay || false,
            isRecommendStatus: props.isRecommend || false,
            stickyPopupStatus: false,   // 置顶弹框
            stickyTypeValue: stickyTypeValue,  // 置顶类型1为首页，2为话题，0为不置顶
            stickyTopicIdValue: [] as string[],
            stickyAtValue: props.stickyAt && dayjs(props.stickyAt).isValid() ? props.stickyAt : '', // 话题置顶时间
            showIndexAtValue: props.threadData?.showIndexAt && dayjs(props.threadData.showIndexAt).isValid() ? props.threadData.showIndexAt : '', // 首页置顶时间
            deletePopupStatus: false,   // 删除二次确认弹框
            conversionVisible: false,
        };
        this.state = {
            ...this.state,
            stickyTopicIdValue: this.getInitialStickyTopicId(stickyTypeValue)
        };

        console.log('Initial state:', this.state);
    }

    private getStickyTypeValueFromProps = (props: PCManagePermissionsProps): number => {
        const rawStickyType = Number(props.stickyType);
        const baseStickyType = Number.isFinite(rawStickyType) && rawStickyType > 0
            ? rawStickyType
            : (typeof props.isSticky === 'number' ? props.isSticky : (props.isSticky ? 1 : 0));

        return props.threadData?.showIndex === true ? (baseStickyType | 2) : baseStickyType;
    };

    // 组件更新时同步 props 到 state
    componentDidUpdate(prevProps: PCManagePermissionsProps) {
        if ((prevProps.id !== this.props.id || !this.canConvertThread()) && this.state.conversionVisible) {
            this.setState({ conversionVisible: false });
        }
        // console.log('componentDidUpdate - prevProps:', prevProps);
        // console.log('componentDidUpdate - current props:', this.props);
        
        // 如果 props 中的状态值发生变化，更新 state
        if (prevProps.isEssence !== this.props.isEssence) {
            // console.log('Updating isEssenceStatus:', this.props.isEssence);
            this.setState({ isEssenceStatus: this.props.isEssence || false });
        }
        if (
            prevProps.isSticky !== this.props.isSticky ||
            prevProps.stickyType !== this.props.stickyType ||
            prevProps.threadData?.showIndex !== this.props.threadData?.showIndex
        ) {
            const stickyTypeValue = this.getStickyTypeValueFromProps(this.props);
            const isStickyBoolean = stickyTypeValue > 0;
            // console.log('Updating sticky states - isSticky:', this.props.isSticky, 'stickyType:', this.props.stickyType);
            // console.log('Calculated isStickyBoolean:', isStickyBoolean, 'stickyTypeValue:', stickyTypeValue);
            this.setState({ 
                isStickStatus: isStickyBoolean,
                stickyTypeValue: stickyTypeValue,
                stickyTopicIdValue: this.getInitialStickyTopicId(stickyTypeValue)
            });
        }
        if (prevProps.stickyAt !== this.props.stickyAt) {
            this.setState({ stickyAtValue: this.props.stickyAt && dayjs(this.props.stickyAt).isValid() ? this.props.stickyAt : '' });
        }
        if (prevProps.threadData?.showIndexAt !== this.props.threadData?.showIndexAt) {
            this.setState({ showIndexAtValue: this.props.threadData?.showIndexAt && dayjs(this.props.threadData.showIndexAt).isValid() ? this.props.threadData.showIndexAt : '' });
        }
        if (prevProps.isSink !== this.props.isSink) {
            // console.log('Updating isSinkStatus:', this.props.isSink);
            this.setState({ isSinkStatus: this.props.isSink || false });
        }
        if (prevProps.isHidden !== this.props.isHidden) {
            // console.log('Updating isHiddenStatus:', this.props.isHidden);
            this.setState({ isHiddenStatus: this.props.isHidden || false });
        }
        if (prevProps.isDisplay !== this.props.isDisplay) {
            // console.log('Updating isDisplayStatus:', this.props.isDisplay);
            this.setState({ isDisplayStatus: this.props.isDisplay || false });
        }
        if (prevProps.isRecommend !== this.props.isRecommend) {
            // console.log('Updating isRecommendStatus:', this.props.isRecommend);
            this.setState({ isRecommendStatus: this.props.isRecommend || false });
        }
    }

    // 处理操作函数，同时更新本地状态
    // 加精
    private handleEssenceClick = () => {
        const { handleEssence } = this.props;
        
        // this.setState((prevState) => ({
        //     isEssenceStatus: !prevState.isEssenceStatus
        // }));
        handleEssence && handleEssence();
    };

    // 置顶
    private handleStickClick = () => {
        const { handleStick, stickyAt, threadData } = this.props;
        console.log('handleStickClick - current isStickStatus:', this.state.isStickStatus);
        this.setState((prevState) => ({
            stickyPopupStatus: true,
            stickyTopicIdValue: (prevState.stickyTopicIdValue && prevState.stickyTopicIdValue.length > 0) ? prevState.stickyTopicIdValue : this.getInitialStickyTopicId(prevState.stickyTypeValue),
            stickyAtValue: stickyAt || prevState.stickyAtValue,
            showIndexAtValue: threadData?.showIndexAt || prevState.showIndexAtValue,
        }));
        handleStick && handleStick();
    };
    // 沉帖
    // private handleSinkClick = () => {
    //     const { handleSink } = this.props;
    //     this.setState((prevState) => ({
    //         isSinkStatus: !prevState.isSinkStatus
    //     }));
    //     handleSink && handleSink();
    // };
    // // 隐藏本帖
    // private handleHiddenClick = () => {
    //     const { handleHidden } = this.props;
    //     this.setState((prevState) => ({
    //         isHiddenStatus: !prevState.isHiddenStatus
    //     }));
    //     handleHidden && handleHidden();
    // };
    // // 屏蔽
    // private handleDisplayClick = () => {
    //     const { handleDisplay } = this.props;
    //     this.setState((prevState) => ({
    //         isDisplayStatus: !prevState.isDisplayStatus
    //     }));
    //     handleDisplay && handleDisplay();
    // };
    // // 推荐
    // private handleSiteClick = (val) => {
    //     const { handleSite } = this.props;
    //     // this.setState((prevState) => ({
    //     //     isRecommendStatus: !prevState.isRecommendStatus
    //     // }));
    //     handleSite && handleSite();
    // };
    // 编辑
    private handleEditClick = () => {
        const { handleEdit } = this.props;
        // this.props.history && this.props.history.push(`/setPost/${id}`);
        handleEdit && handleEdit();
    };
    // 删除
    private handleDeleteClick = () => {
        this.setState((prevState) => ({
            deletePopupStatus: !prevState.deletePopupStatus
        }));
        
        // this.props.handleDelete && this.props.handleDelete();
    };

    private renderToggle = (checked: boolean, onClick: () => void) => (
        <button
            type='button'
            className={classNames(styles.manageSwitch, checked ? styles.manageSwitchChecked : '')}
            onClick={onClick}
            aria-pressed={checked}
        >
            <span className={styles.manageSwitchTrack} />
            <span className={styles.manageSwitchThumb} />
        </button>
    );

    private handleStickySwitch = (type: number) => {
        this.setState((prevState) => ({
            stickyTypeValue: (prevState.stickyTypeValue & type) ? (prevState.stickyTypeValue & ~type) : (prevState.stickyTypeValue | type),
            stickyTopicIdValue: type === 1 && (prevState.stickyTypeValue & type) ? [] : prevState.stickyTopicIdValue,
            stickyAtValue: (() => {
                const nextStickyTypeValue = (prevState.stickyTypeValue & type) ? (prevState.stickyTypeValue & ~type) : (prevState.stickyTypeValue | type);
                return type === 1 && nextStickyTypeValue !== 0 ? prevState.stickyAtValue : (nextStickyTypeValue === 0 ? '' : prevState.stickyAtValue);
            })(),
            showIndexAtValue: (() => {
                const nextStickyTypeValue = (prevState.stickyTypeValue & type) ? (prevState.stickyTypeValue & ~type) : (prevState.stickyTypeValue | type);
                return type === 2 && nextStickyTypeValue !== 0 ? prevState.showIndexAtValue : (nextStickyTypeValue === 0 ? '' : prevState.showIndexAtValue);
            })()
        }));
    };

    private getStickyTopics = () => {
        const { topicList, threadData } = this.props;
        if (Array.isArray(topicList) && topicList.length > 0) {
            return topicList;
        }
        return Array.isArray(threadData?.topics) ? threadData.topics : [];
    };

    private getInitialStickyTopicId = (stickyTypeValue = this.state?.stickyTypeValue || 0): string[] => {
        const { threadData } = this.props;
        const stickyTopics = this.getStickyTopics();
        const isTopicSticky = (stickyTypeValue & 1) === 1;

        if (!isTopicSticky || stickyTopics.length === 0) {
            return [];
        }

        const stickyTopicsFromApi = threadData?.stickyTopics;
        if (Array.isArray(stickyTopicsFromApi) && stickyTopicsFromApi.length > 0) {
            return stickyTopicsFromApi.map((t: any) => String(t?.id ?? t?.name ?? t?.title ?? '')).filter(Boolean);
        }

        const stickyTopicIds = threadData?.stickyTopicIds;
        if (Array.isArray(stickyTopicIds) && stickyTopicIds.length > 0) {
            return stickyTopicIds.map(String).filter(Boolean);
        }

        if (typeof stickyTopicIds === 'string' && stickyTopicIds.trim()) {
            try {
                const parsed = JSON.parse(stickyTopicIds);
                if (Array.isArray(parsed) && parsed.length > 0) {
                    return parsed.map(String).filter(Boolean);
                }
            } catch (error) {
                const ids = stickyTopicIds.split(',').map((s: string) => s.trim()).filter(Boolean);
                if (ids.length > 0) {
                    return ids;
                }
            }
        }

        return stickyTopics.map((t: any) => String(t?.id ?? t?.name ?? t?.title ?? '')).filter(Boolean);
    };

    // private getTopicBadge = (topic: any) => {
    //     if (topic?.isRecommended) {
    //         return { text: '荐', className: styles.stickyTopicBadgeRecommend };
    //     }
    //     if (topic?.isHot) {
    //         return { text: '热', className: styles.stickyTopicBadgeHot };
    //     }
    //     if (topic?.isReward) {
    //         return { text: '奖', className: styles.stickyTopicBadgeReward };
    //     }
    //     return null;
    // };
    private getTopicBadge = (topic: any) => {
        if (topic?.isHot) {
        return { text: '热', img: 'common/topic_hot.png', className: styles.stickyTopicBadgeRecommend };
        }
        if (topic?.isNew) {
        return { text: '新', img: 'common/topic_new.png', className: styles.stickyTopicBadgeRecommend };
        }
        if (topic?.isRecommended) {
        return { text: '荐', img: 'common/topic_recommend.png', className: styles.stickyTopicBadgeRecommend };
        }
        return null;
    };

    private handleStickyTopicSelect = (topic: any) => {
        const topicValue = String(topic?.id ?? topic?.name ?? topic?.title ?? '');
        this.setState((prevState) => {
            const currentIds: string[] = Array.isArray(prevState.stickyTopicIdValue) ? prevState.stickyTopicIdValue : [];
            const idx = currentIds.indexOf(topicValue);
            const nextIds = idx >= 0
                ? currentIds.filter((id: string) => id !== topicValue)
                : [...currentIds, topicValue];
            return { stickyTopicIdValue: nextIds };
        });
    };

    private handleStickyConfirm = () => {
        const { stickyTypeValue, stickyTopicIdValue, stickyAtValue, showIndexAtValue } = this.state;
        const isTopicSticky = (stickyTypeValue & 1) === 1;
        const isGlobalSticky = (stickyTypeValue & 2) === 2;
        const selectedTopicIds: string[] = Array.isArray(stickyTopicIdValue) ? stickyTopicIdValue : [];

        if (isTopicSticky && selectedTopicIds.length === 0) {
            Toast.info({ content: '请选择1个话题' });
            return;
        }

        if (isTopicSticky && !stickyAtValue) {
            Toast.info({ content: '请选择话题置顶截止时间' });
            return;
        }

        if (isGlobalSticky && !showIndexAtValue) {
            Toast.info({ content: '请选择首页置顶截止时间' });
            return;
        }

        this.createThreadOpera('isSticky', stickyTypeValue);
    };
    

    // 选择置顶类型
    private setStickyType = (type: number) => {
        this.setState({ 
            stickyTypeValue: type,
            // 取消置顶时清空时间
            stickyAtValue: type === 0 ? '' : this.state.stickyAtValue
        });
    };

    // 选择置顶时间
    private onChangeStickyAt = (date: any, dateString: string | string[]) => {
        if (date && date.isValid()) {
            this.setState({ stickyAtValue: date.format('YYYY-MM-DD HH:mm') });
        } else {
            this.setState({ stickyAtValue: '' });
        }
    };

    private onChangeShowIndexAt = (date: any, dateString: string | string[]) => {
        if (date && date.isValid()) {
            this.setState({ showIndexAtValue: date.format('YYYY-MM-DD HH:mm') });
        } else {
            this.setState({ showIndexAtValue: '' });
        }
    };
    // 确认置顶
    stickyConfirm = () => {
        // 调用置顶接口
        this.closePopup();
    };

    // 关闭弹框
    private closePopup = () => {
        this.setState({ 
        stickyPopupStatus: false,
        deletePopupStatus: false
        });
    };

    // 确认删除
    private deletThreadConfirm = () => {
        // 删除确认逻辑
        this.closePopup();
    };

    // 复制预览链接
    private copyPreviewLink = () => {
        const { threadData, id } = this.props;
        
        if (!threadData?.code || !id) {
            Toast.info({ content: '链接信息不完整，无法复制' });
            return;
        }

        // 从当前URL动态获取域名
        const origin = window.location.origin;
        const url = `${origin}/threadDetail/${id}?code=${threadData.code}`;
        
        // 使用 navigator.clipboard API 复制到剪贴板
        navigator.clipboard.writeText(url).then(() => {
            Toast.success({ content: '链接已复制' });
        }).catch(() => {
            // 如果 clipboard API 不可用，使用备用方案
            const textArea = document.createElement('textarea');
            textArea.value = url;
            document.body.appendChild(textArea);
            textArea.select();
            try {
                document.execCommand('copy');
                Toast.success({ content: '链接已复制' });
            } catch (err) {
                Toast.info({ content: '复制失败，请手动复制' });
            }
            document.body.removeChild(textArea);
        });
    };

    // 帖子置顶、取消置顶，沉帖，精华，屏蔽，推荐，删除
    createThreadOpera = (val, status = true) => {
        const { thread, id, goBack, getThreadDetail, isEssence, isRecommend } = this.props;
        // console.log(isEssence, '精华', isRecommend, '推荐', val, status, '参数');
        // if(val === 'isRecommend' && isEssence) {    // 如果是推荐，且已加精，不允许开启推荐
        //     Toast.info({content: '帖子已加精，不能同时推荐'});
        //     return;
        // }
        // if(val === 'isEssence' && isRecommend) {    // 如果是加精，且已推荐，不允许开启加精
        //     Toast.info({content: '帖子已推荐，不能同时加精'});
        //     return;
        // }
        let { stickyAtValue, showIndexAtValue, stickyTypeValue, stickyTopicIdValue } = this.state;
        if (thread) {
            let params: any = {};
            if(val == 'isSticky') {
                const isTopicSticky = (stickyTypeValue & 1) === 1;
                const isGlobalSticky = (stickyTypeValue & 2) === 2;
                const selectedTopicIds: string[] = Array.isArray(stickyTopicIdValue) ? stickyTopicIdValue : [];
                const stickyTopicIds = isTopicSticky ? selectedTopicIds : [];

                params = {
                    id,
                    showIndex: isGlobalSticky,
                    showIndexAt: isGlobalSticky ? (showIndexAtValue || '') : '',
                };
                if (isTopicSticky) {
                    params.isSticky = true;
                    params.stickyType = 1;
                    params.stickyAt = stickyAtValue || '';
                    params.stickyTopicIds = stickyTopicIds;
                } else if (isGlobalSticky) {
                    params.isSticky = false;
                    params.stickyType = 0;
                    params.stickyAt = '';
                    params.stickyTopicIds = [];
                } else {
                    params.isSticky = false;
                    params.stickyType = 0;
                    params.stickyAt = '';
                    params.showIndexAt = '';
                    params.stickyTopicIds = [];
                }
            } else {
                params = {
                    [val]: !status,
                    id: id
                }
            }
            thread.createThreadOpera(params).then(res => {
                if(res.code == 0) {
                    Toast.success({
                        content: getManageOperationSuccessMessage(val, status, stickyTypeValue)
                    });
                    if(val == 'isSticky') { // 如果是置顶，需要关闭置顶弹框
                        this.setState({
                            stickyPopupStatus: false
                        })
                    }
                    if(val == 'isDeleted' && goBack){
                        goBack();
                    }
                    getThreadDetail && getThreadDetail();
                }

            })
        }
    }

    private canConvertThread = () => (
        this.props.canConvert === true
        && !shouldHideThreadConversion(this.props.threadData)
        && typeof this.props.handleConvert === 'function'
    );

    private convertThread = async (payload: ThreadConversionPayload) => {
        if (!this.canConvertThread() || String(payload.threadId) !== String(this.props.id)) {
            throw new Error('当前帖子不可转换');
        }
        const reason = getThreadConversionBlockedReason(this.props.threadData);
        if (reason) {
            Toast.info({ content: reason });
            throw new Error(reason);
        }
        await this.props.handleConvert!(payload);
    };

    private openConversion = () => {
        const reason = getThreadConversionBlockedReason(this.props.threadData);
        if (reason) {
            Toast.info({ content: reason });
            return;
        }
        this.setState({ conversionVisible: true });
    };

    private handleConversionSuccess = async () => {
        this.setState({ conversionVisible: false });
        try {
            await this.props.getThreadDetail?.();
        } catch {
            // 转换已完成，刷新失败不应显示“转换失败”。
        } finally {
            Toast.success({ content: '帖子转换成功' });
        }
    };

    // 检查是否有权限
    private hasPermissions = (): boolean => {
        const props = this.props;
        return !!(
            props.canEdit ||
            props.canDelete ||
            props.canEssence ||
            props.canStick ||
            props.canSink ||
            props.canHidden ||
            props.canDisplay ||
            props.canRecommend ||
            this.canConvertThread()
        );
    };

    render() {
        const props = this.props;
        // console.log('Render - props:', props);
        // console.log('Render - state:', this.state);
        
        if (!this.hasPermissions()) {
            // console.log('No permissions, returning null');
            return null;
        }
        // 解构
        const { 
            stickyPopupStatus, 
            stickyTypeValue, 
            stickyTopicIdValue,
            stickyAtValue,
            showIndexAtValue,
            deletePopupStatus
        } = this.state;
    
        // 在组件顶部定义互斥检查函数
        const checkEssenceConflict = (): boolean => {
            // 如果要开启精华，检查是否已推荐
            if (!props.isEssence && props.isRecommend) {
                Toast.info({content: '帖子已推荐，不能同时加精'});
                return true; // 存在冲突
            }
            return false;
        };

        const checkRecommendConflict = (): boolean => {
            // 如果要开启推荐，检查是否已加精
            if (!props.isRecommend && props.isEssence) {
                Toast.info({content: '帖子已加精，不能同时推荐'});
                return true; // 存在冲突
            }
            return false;
        };
        const isDisplayChecked = !props.isDisplay;
        const stickyTopics = this.getStickyTopics();
        const isTopicSticky = (stickyTypeValue & 1) === 1;
        const isGlobalSticky = (stickyTypeValue & 2) === 2;
        const showStickyTopicSelect = isTopicSticky;
        const stickyConfirmDisabled = (isTopicSticky && !stickyAtValue) || (isTopicSticky && (!stickyTopicIdValue || !Array.isArray(stickyTopicIdValue) || stickyTopicIdValue.length === 0 || stickyTopics.length === 0)) || (isGlobalSticky && !showIndexAtValue);
        // console.log('Render - stickyTypeValue:', stickyTypeValue, 'type:', typeof stickyTypeValue);
        // console.log('Render - stickyAtValue:', stickyAtValue, 'type:', typeof stickyAtValue);
        // console.log('Render - isStickStatus:', this.state.isStickStatus, 'display text should be:', this.state.isStickStatus ? '取消置顶' : '置顶');
        return (
            <div className={styles.box}>
            <div className={`${props.className} ${styles.manageListBox}`}>
                <div className={styles.titBox}>
                    <div className={styles.title}>管理</div>
                </div>
                <div className={styles.manageBox}>
                    {!!(props.isApproved && props.canEssence) && (
                        <div className={styles.manageBtn}>
                            <div className={styles.manageText}>
                                {props.isEssence ? '' : ''}精华
                            </div>
                            {this.renderToggle(!!props.isEssence, () => {
                                    // if (checkEssenceConflict()) {
                                    //     return;
                                    // }
                                    this.createThreadOpera('isEssence', props.isEssence);
                                })}
                        </div>
                    )}
                    {!!(props.isApproved && props.canStick) && (
                        <div className={styles.manageBtn} onClick={()=>this.handleStickClick()}>
                            {/* <div className={styles.manageText}>{this.state.isStickStatus ? '取消' : ''}置顶</div> */}
                            <div className={styles.manageText}>{this.state.isStickStatus ? '取消' : ''}置顶</div>
                            <img src={`${BASE_IMG_URL}/common/menu3.png`} alt="" className={styles.icon}/>
                            {/* <Switch defaultChecked={props.isStick ? true : false} onChange={props.handleStick} /> */}
                        </div>
                    )}
                    {!!(props.isApproved && props.canSink) && (
                        <div className={styles.manageBtn}>
                            <div className={styles.manageText}>{props.isSink ? '' : ''}沉帖</div>
                            {this.renderToggle(!!props.isSink, () => this.createThreadOpera('isSink', props.isSink))}
                        </div>
                    )}

                    {!!(props.isApproved && props.canDisplay && props.type !== undefined && props.type < 2) && (
                        <div className={styles.manageBtn}>
                            <div className={styles.manageText}>{!props.isDisplay ? '' : ''}屏蔽</div>
                            {this.renderToggle(isDisplayChecked, () => this.createThreadOpera('isDisplay', props.isDisplay))}
                        </div>
                    )}
                    {!!(props.isApproved && props.canHidden) && (
                        <div className={styles.manageBtn}>
                            {/* <div className={styles.manageText}>{!props.isHidden ? '隐藏' : '展示'}本帖{!!props.canDisplay}</div> */}
                            <div className={styles.manageText}>仅自己可见</div>
                            {this.renderToggle(!!props.isHidden, () => this.createThreadOpera('isHidden', props.isHidden))}
                        </div>
                    )}
                    {!!(props.isApproved && props.canRecommend) && (
                        <div className={styles.manageBtn}>
                            <div className={styles.manageText}>
                                {props.isRecommend ? '' : ''}推荐
                            </div>
                            {this.renderToggle(!!props.isRecommend, () => {
                                    // if (checkRecommendConflict()) {
                                    //     return;
                                    // }
                                    this.createThreadOpera('isRecommend', props.isRecommend);
                                })}
                        </div>
                    )}
                    
                    {/* 复制预览链接按钮 - 仅当有code且定时未过期时显示 */}
                    {!!(props.threadData?.code && props.threadData?.fixedAt && !isScheduleExpired(props.threadData.fixedAt)) && (
                        <div className={styles.manageBtn} onClick={() => this.copyPreviewLink()}>
                            <div className={styles.manageText}>复制链接</div>
                            <img src={`${BASE_IMG_URL}/common/copy.png`} alt="" className={styles.icon}/>
                        </div>
                    )}

                    {!!(props.canEdit) && (
                        <div className={styles.manageBtn} onClick={() => this.handleEditClick()}>
                            <div className={styles.manageText}>编辑</div>
                            <img src={`${BASE_IMG_URL}/common/edit.png`} alt="" className={styles.icon}/>
                        </div>
                    )}

                    {!!(props.canDelete) && (
                        <div className={classNames(styles.manageBtn, styles.deleteBtn)} onClick={()=>this.handleDeleteClick()}>
                            <div className={styles.manageText}>删除</div>
                            <img src={`${BASE_IMG_URL}/common/delete1.png`} alt="" className={classNames(styles.icon, styles.deleteIcon1)}/>
                            <img src={`${BASE_IMG_URL}/common/delete2.png`} alt="" className={classNames(styles.icon, styles.deleteIcon2)}/>
                        </div>
                    )} 
                    {this.canConvertThread() && (
                        <button
                            type="button"
                            className={classNames(styles.manageBtn, styles.conversionBtn)}
                            onClick={this.openConversion}
                        >
                            <span className={styles.manageText}>
                                {Number(props.threadData?.type) === 2 ? '转为普通帖' : '转为问题反馈帖'}
                            </span>
                        </button>
                    )}
                    {/* {props.isApproved && props.canHot && (
                        <div className={styles.manageBtn} onClick={props.handleHot}>
                        {props.isHot ? '取消' : ''}热门
                        </div>
                    )} */}

                    

                    {/* {props.isApproved && props.canProhibitedComment && (
                        <div className={styles.manageBtn} onClick={props.handleProhibited}>
                        {props.isProhibited ? '允许' : '禁止'}评论
                        </div>
                    )} */}

                    {/* {props.isApproved && props.canSolve && (
                        <div className={styles.manageBtn} onClick={props.handleSolve}>
                        帮TA处理
                        </div>
                    )} */}
                </div>
            </div>
            {this.canConvertThread() && (
                <ThreadConversion
                    key={String(props.id)}
                    visible={this.state.conversionVisible}
                    threadId={props.id}
                    sourceType={Number(props.threadData?.type)}
                    initialTopics={props.threadData?.topics || []}
                    imageCount={props.threadData?.images?.length || 0}
                    hasVideo={Boolean(props.threadData?.video?.url)}
                    onClose={() => this.setState({ conversionVisible: false })}
                    onConvert={this.convertThread}
                    onSuccess={this.handleConversionSuccess}
                />
            )}
            {/* 置顶弹框 */}
            {stickyPopupStatus && (
                <div className={styles.stickyPopupMask} onClick={() => this.closePopup()}>
                    <div className={styles.stickyPopupCard} onClick={(e) => e.stopPropagation()}>
                        <div className={styles.stickyPopupHeader}>
                            <div className={styles.stickyPopupTitle}>置顶设置</div>
                            <img
                                src={`${BASE_IMG_URL}/common/close2.png`}
                                alt=""
                                className={styles.stickyPopupClose}
                                onClick={() => this.closePopup()}
                            />
                        </div>

                        <div className={styles.stickyPopupBody}>
                            <div className={styles.stickySettingRow}>
                                <div className={styles.stickySettingLabel}>首页置顶</div>
                                <div className={styles.stickySettingAction}>
                                    {this.renderToggle(isGlobalSticky, () => this.handleStickySwitch(2))}
                                    <span className={styles.stickySettingHint}>在精选页中置顶</span>
                                </div>
                            </div>

                            {isGlobalSticky && (
                                <div className={styles.stickyFormRow}>
                                    <div className={styles.stickyFormLabel}>
                                        <span className={styles.requiredMark}>*</span>
                                        <span>置顶截止时间</span>
                                    </div>
                                    <DatePicker
                                        placeholder='请选择首页置顶截止时间'
                                        value={showIndexAtValue && dayjs(showIndexAtValue).isValid() ? dayjs(showIndexAtValue) : null}
                                        onChange={this.onChangeShowIndexAt}
                                        className={styles.stickyDeadlineInput}
                                        format="YYYY-MM-DD HH:mm"
                                        showTime={{ format: 'HH:mm' }}
                                    />
                                </div>
                            )}

                            <div className={styles.stickySettingRow}>
                                <div className={styles.stickySettingLabel}>话题置顶</div>
                                <div className={styles.stickySettingAction}>
                                    {this.renderToggle(isTopicSticky, () => this.handleStickySwitch(1))}
                                    <span className={styles.stickySettingHint}>在所属话题中置顶</span>
                                </div>
                            </div>

                            {showStickyTopicSelect && (
                                <div className={styles.stickyFormRow}>
                                    <div className={styles.stickyFormLabel}>
                                        <span className={styles.requiredMark}>*</span>
                                        <span>选择话题</span>
                                    </div>
                                    <div className={styles.stickyTopicList}>
                                        {stickyTopics.length > 0 ? stickyTopics.map((topic: any, idx: number) => {
                                            const badge = this.getTopicBadge(topic);
                                            const topicValue = String(topic?.id ?? topic?.name ?? topic?.title ?? '');
                                            const selectedIds: string[] = Array.isArray(stickyTopicIdValue) ? stickyTopicIdValue : [];
                                            const isTopicSelected = selectedIds.includes(topicValue);
                                            return (
                                                <button
                                                    type='button'
                                                    key={topic?.id ?? `sticky-topic-${idx}`}
                                                    className={classNames(styles.stickyTopicChip, isTopicSelected ? styles.stickyTopicChipActive : '')}
                                                    onClick={() => this.handleStickyTopicSelect(topic)}
                                                >
                                                    <span className={styles.stickyTopicName}>
                                                        <img
                                                            className={styles.stickyTopicHashIcon}
                                                            src={isTopicSelected
                                                                ? `${BASE_IMG_URL}/detail/topic_icon2.png`
                                                                : `${BASE_IMG_URL}/detail/topic_icon1.png`}
                                                            alt="#"
                                                        />
                                                        {topic?.name || topic?.title || '未命名话题'}
                                                    </span>
                                                    {badge && (
                                                       
                                                        <img
                                                            className={styles.stickyTopicBadgeImg}
                                                            src={`${BASE_IMG_URL}/${badge.img}`}
                                                            alt={badge.text}
                                                            />
                                                    )}
                                                </button>
                                            );
                                        }) : (
                                            <div className={styles.stickyTopicPlaceholder}>当前帖子暂无所属话题</div>
                                        )}
                                    </div>
                                </div>
                            )}

                            {isTopicSticky && (
                                <div className={styles.stickyFormRow}>
                                    <div className={styles.stickyFormLabel}>
                                        <span className={styles.requiredMark}>*</span>
                                        <span>置顶截止时间</span>
                                    </div>
                                    <DatePicker
                                        placeholder='请选择话题置顶截止时间'
                                        value={stickyAtValue && dayjs(stickyAtValue).isValid() ? dayjs(stickyAtValue) : null}
                                        onChange={this.onChangeStickyAt}
                                        className={styles.stickyDeadlineInput}
                                        format="YYYY-MM-DD HH:mm"
                                        showTime={{ format: 'HH:mm' }}
                                    />
                                </div>
                            )}
                        </div>

                        <div className={styles.stickyPopupFooter}>
                            <button type='button' className={styles.stickyPopupCancel} onClick={() => this.closePopup()}>
                                取消
                            </button>
                            <button
                                type='button'
                                className={classNames(styles.stickyPopupConfirm, stickyConfirmDisabled ? styles.stickyPopupConfirmDisabled : '')}
                                onClick={this.handleStickyConfirm}
                            >
                                确定
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* 删除二次确认弹框 */}
            <CommonAlert
                visible={deletePopupStatus}
                title='帖子删除后无法撤销，请确认是否删除'
                onCancelChange={()=>this.closePopup()}
                onHidePopup={()=>this.closePopup()}
                onConfirmButtonChange={()=> this.createThreadOpera('isDeleted', false)}
            >     
            </CommonAlert>
        </div>
        );
    }
}

export default PCManagePermissions;
